(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["calculator-premium"] && !Shopify.designMode) return;
  try {
    (() => {
  const sizes = [100,150,200,250,300,330,400,450,500,600,800,900,1000,1200];
  const rates = [[200,133,100,80,100,91,75,67,60,50,50,44,50,42],[133,89,67,53,67,61,50,44,40,33,33,30,33,28],[100,67,50,40,50,45,37,33,30,25,25,22,25,21],[80,53,40,32,40,36,30,27,24,20,20,18,20,17],[100,67,50,40,44,40,33,30,37,22,21,19,20,17],[91,61,45,36,40,37,30,27,24,20,19,17,18,15],[75,50,37,30,33,30,25,22,20,17,16,14,15,13],[67,44,33,27,30,27,22,20,18,15,14,12,13,11],[60,40,30,24,37,24,20,18,16,13,12,11,12,10],[50,33,25,20,22,20,17,15,13,11,10,9,10,8],[50,33,25,20,21,19,16,14,12,10,9,8,9,7],[44,30,22,18,19,17,14,12,11,9,8,7,8,6],[50,33,25,20,20,18,15,13,12,10,9,8,8,7],[42,28,21,17,17,15,13,11,10,8,7,6,7,6]];
  function estimateClips(length, width, rawArea) {
    const value = rawArea.trim();
    if (value.length > 24 || !/^(?:(?:\d+|\d{1,3}(?:,\d{3})+)(?:\.\d+)?|\.\d+)$/.test(value)) return null;
    const rate = rates[sizes.indexOf(Number(length))]?.[sizes.indexOf(Number(width))];
    if (!rate) return null;
    const [whole,fraction=''] = value.replaceAll(',','').split('.');
    const numerator = BigInt((whole || '0') + fraction);
    if (numerator <= 0n) return null;
    const denominator = 10n ** BigInt(fraction.length);
    const count = (numerator * BigInt(rate) + denominator - 1n) / denominator;
    if (count > BigInt(Number.MAX_SAFE_INTEGER)) return null;
    return Number(count);
  }
  function initialise(root) {
    if (root.dataset.ready) return;
    const length = root.querySelector('[data-calculator-length]');
    const width = root.querySelector('[data-calculator-width]');
    const area = root.querySelector('[data-calculator-area]');
    const result = root.querySelector('[data-calculator-result]');
    const status = root.querySelector('[data-calculator-status]');
    const error = root.querySelector('[data-calculator-error]');
    const announcement = root.querySelector('[data-calculator-announcement]');
    const formatter = new Intl.NumberFormat(document.documentElement.lang || 'en-AU');
    let timer;
    function update() {
      const count = estimateClips(length.value,width.value,area.value);
      const invalid = count === null;
      area.setAttribute('aria-invalid',String(invalid));
      error.hidden = !invalid;
      result.hidden = invalid;
      status.hidden = !invalid;
      status.textContent = invalid ? root.dataset.invalidResult : '';
      if (!invalid) result.textContent = formatter.format(count);
      clearTimeout(timer);
      timer = setTimeout(() => {
        announcement.textContent = invalid ? root.dataset.invalidResult : root.dataset.announcement.replace('[quantity]',formatter.format(count));
      },400);
    }
    [length,width,area].forEach(control=>{ control.disabled=false; control.addEventListener('input',update); });
    root.dataset.ready = 'true';
    update();
    function cleanup(event) {
      if (event.target.contains(root)) {
        clearTimeout(timer);
        [length,width,area].forEach(control=>control.removeEventListener('input',update));
        delete root.dataset.ready;
        document.removeEventListener('shopify:section:unload',cleanup);
      }
    }
    document.addEventListener('shopify:section:unload',cleanup);
  }
  function scan() { document.querySelectorAll('[data-clip-calculator]').forEach(initialise); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',scan,{once:true});
  else scan();
  document.addEventListener('shopify:section:load',scan);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-premium-styles"] && !Shopify.designMode) return;
  try {
    function initialisePremiumHeaders() {
    customElements.whenDefined('header-component').then(() => {
      document.querySelectorAll('[data-premium-header]').forEach((header) => {
        if (header.dataset.premiumInitialised) return;
        header.dataset.premiumInitialised = 'true';
        const section = header.closest('.shopify-section-header');
        const drawer = section.querySelector('.premium-drawer');
        const opener = header.querySelector('[data-menu-toggle]');
        const closer = drawer.querySelector('[data-menu-toggle]');
        const triggers = [...section.querySelectorAll('[data-premium-trigger]')];
        const background = [...document.querySelectorAll('main, footer')];
        const priorInert = new Map();
        let drawerOpen = false;
        let returnFocus = false;
        const hoverTimers = new Map();
        const cancelHoverClose = (item) => {
          clearTimeout(hoverTimers.get(item));
          hoverTimers.delete(item);
        };
        const syncPanels = () => {
          triggers.forEach((trigger) => {
            const expanded = trigger.parentElement.classList.contains('is-expanded');
            const panel = document.getElementById(trigger.getAttribute('aria-controls'));
            trigger.setAttribute('aria-expanded', String(expanded));
            if (!expanded) trigger.dataset.premiumPinned = 'false';
            panel.hidden = !expanded;
            panel.inert = !expanded;
            panel.querySelectorAll('a, button').forEach((link) => link.removeAttribute('tabindex'));
          });
        };
        const closeDropdowns = () => {
          hoverTimers.forEach((timer) => clearTimeout(timer));
          hoverTimers.clear();
          triggers.forEach((trigger) => trigger.parentElement.classList.remove('is-expanded'));
          header.classList.remove('header--megamenu-visible');
          syncPanels();
        };
        header.querySelectorAll('[data-dropdown-parent]').forEach((item) => {
          const trigger = item.querySelector('[data-premium-trigger]');
          const panel = item.querySelector('.premium-nav-panel');
          item.addEventListener('mouseenter', () => cancelHoverClose(item), true);
          panel.addEventListener('mouseenter', () => cancelHoverClose(item));
          item.addEventListener('mouseleave', (event) => {
            if (header.classList.contains('header--is-hamburger')) return;
            event.stopImmediatePropagation();
            cancelHoverClose(item);
            if (item.contains(event.relatedTarget) || item.contains(document.activeElement) || trigger.dataset.premiumPinned === 'true') return;
            hoverTimers.set(item, setTimeout(() => {
              hoverTimers.delete(item);
              if (item.matches(':hover') || item.contains(document.activeElement) || trigger.dataset.premiumPinned === 'true') return;
              item.classList.remove('is-expanded');
              const expanded = header.querySelector('[data-dropdown-parent].is-expanded');
              header.classList.toggle('header--megamenu-visible', Boolean(expanded));
              syncPanels();
            }, 200));
          }, true);
        });
        const syncDrawer = () => {
          const open = document.body.classList.contains('nav--is-visible');
          const focusWasInside = drawer.contains(document.activeElement);
          drawer.inert = !open;
          drawer.setAttribute('aria-hidden', String(!open));
          opener.setAttribute('aria-expanded', String(open));
          if (open && !drawerOpen) {
            background.forEach((element) => {
              priorInert.set(element, element.inert);
              element.inert = true;
            });
            syncPanels();
            closer.focus();
          } else if (!open && drawerOpen) {
            priorInert.forEach((inert, element) => { element.inert = inert; });
            priorInert.clear();
            closeDropdowns();
            if (returnFocus || focusWasInside || document.activeElement === document.body) {
              const target = opener.getClientRects().length ? opener : header.querySelector('.logo__image-link');
              target?.focus();
            }
            returnFocus = false;
          }
          drawerOpen = open;
        };
        const closeDrawer = () => {
          returnFocus = true;
          header.hideNav();
          syncDrawer();
        };
        section.addEventListener('click', (event) => {
          const toggle = event.target.closest('[data-menu-toggle]');
          const trigger = event.target.closest('[data-premium-trigger]');
          if (toggle) {
            event.preventDefault();
            event.stopImmediatePropagation();
            if (drawerOpen) closeDrawer();
            else {
              header.showNav();
              syncDrawer();
            }
          } else if (trigger) {
            event.preventDefault();
            event.stopImmediatePropagation();
            const open = trigger.parentElement.classList.contains('is-expanded');
            const desktopHover = header.contains(trigger) && open && trigger.dataset.premiumPinned !== 'true';
            trigger.parentElement.classList.toggle('is-expanded', !open || desktopHover);
            trigger.dataset.premiumPinned = String(!open || desktopHover);
            const desktopOpen = [...header.querySelectorAll('[data-dropdown-parent]')].some((item) => item.classList.contains('is-expanded'));
            header.classList.toggle('header--megamenu-visible', desktopOpen);
            syncPanels();
          } else if (drawerOpen && event.target.closest('a, [data-popdown-toggle]')) {
            closeDrawer();
          }
        }, true);
        const onKeyDown = (event) => {
          if (event.key === 'Escape') {
            if (drawerOpen) {
              event.preventDefault();
              event.stopImmediatePropagation();
              closeDrawer();
            } else if (section.querySelector('.is-expanded')) {
              event.preventDefault();
              event.stopImmediatePropagation();
              const parent = event.target.closest('.is-expanded') || section.querySelector('.is-expanded');
              const trigger = parent.querySelector('[data-premium-trigger]');
              closeDropdowns();
              trigger?.focus();
            }
          }
          if (drawerOpen && event.key === 'Tab') {
            const focusable = [...drawer.querySelectorAll('a[href], button')].filter((element) => !element.closest('[inert], [hidden]') && element.getClientRects().length && !element.disabled);
            const first = focusable[0];
            const last = focusable[focusable.length - 1];
            if (event.shiftKey && (document.activeElement === first || !drawer.contains(document.activeElement))) {
              event.preventDefault();
              last?.focus();
            } else if (!event.shiftKey && (document.activeElement === last || !drawer.contains(document.activeElement))) {
              event.preventDefault();
              first?.focus();
            }
          }
        };
        document.addEventListener('keydown', onKeyDown, true);
        const onKeyUp = (event) => {
          if ((drawerOpen || section.contains(event.target)) && ['Tab', ' ', 'Escape', 'Enter'].includes(event.key)) event.stopImmediatePropagation();
        };
        const onOutsideClick = (event) => {
          if (!section.contains(event.target)) closeDropdowns();
        };
        document.addEventListener('keyup', onKeyUp, true);
        document.addEventListener('click', onOutsideClick);
        section.addEventListener('focusin', (event) => {
          if (!drawerOpen) {
            header.querySelectorAll('[data-dropdown-parent].is-expanded').forEach((item) => {
              if (!item.contains(event.target)) item.classList.remove('is-expanded');
            });
            syncPanels();
          }
        });
        const panelObserver = new MutationObserver(syncPanels);
        const drawerObserver = new MutationObserver(syncDrawer);
        panelObserver.observe(section, { subtree: true, attributes: true, attributeFilter: ['class'] });
        drawerObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
        const unload = (event) => {
          if (event.target !== section) return;
          hoverTimers.forEach((timer) => clearTimeout(timer));
          hoverTimers.clear();
          panelObserver.disconnect();
          drawerObserver.disconnect();
          document.removeEventListener('keydown', onKeyDown, true);
          document.removeEventListener('keyup', onKeyUp, true);
          document.removeEventListener('click', onOutsideClick);
          document.removeEventListener('shopify:section:unload', unload);
          if (drawerOpen) header.hideNav();
          priorInert.forEach((inert, element) => { element.inert = inert; });
          priorInert.clear();
        };
        document.addEventListener('shopify:section:unload', unload);
        syncPanels();
        syncDrawer();
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialisePremiumHeaders);
  else initialisePremiumHeaders();
  document.addEventListener('shopify:section:load', initialisePremiumHeaders);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["retainer-shipping-message"] && !Shopify.designMode) return;
  try {
    function syncRetainerShipping() {
    document.querySelectorAll('[data-retainer-shipping-message]').forEach((message) => {
      const form = message.closest('[data-cart-form]');
      const rows = [...form.querySelectorAll('[data-item]')];
      const retainerRows = rows.filter((row) => row.hasAttribute('data-retainer-box'));
      const boxes = retainerRows.reduce((total, row) => {
        const quantity = Number(row.querySelector('input[name="updates[]"]')?.value);
        return total + (Number.isFinite(quantity) ? Math.max(0, quantity) : 0);
      }, 0);
      const otherItems = rows.some((row) => !row.hasAttribute('data-retainer-box'));
      message.hidden = boxes === 0;
      const copy = boxes >= 3 ? message.dataset.retainerQualified : boxes === 2 ? message.dataset.retainerPendingOne : message.dataset.retainerPendingTwo;
      const text = message.querySelector('[data-retainer-shipping-copy]');
      if (text.textContent !== copy) text.textContent = copy;
      message.querySelector('[data-retainer-shipping-note]').hidden = !otherItems;
      form.querySelectorAll('[data-retainer-suppress]').forEach((banner) => { banner.hidden = boxes > 0; });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncRetainerShipping);
  else syncRetainerShipping();
  document.addEventListener('theme:cart:change', syncRetainerShipping);
  document.addEventListener('shopify:section:load', syncRetainerShipping);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["stockists-premium"] && !Shopify.designMode) return;
  try {
    (() => {
 const stateNames={ACT:'Australian Capital Territory',NSW:'New South Wales',NT:'Northern Territory',QLD:'Queensland',SA:'South Australia',TAS:'Tasmania',VIC:'Victoria',WA:'Western Australia'};
 function normalise(value){return String(value).normalize('NFKD').replace(/[\u0300-\u036f]/g,'').toLowerCase().replace(/[,]/g,' ').replace(/\s+/g,' ').trim();}
 function matchesStockist(text,query,state){
  let remaining=normalise(query);
  const states=[];
  const names=Object.entries(stateNames).map(([code,name])=>[code,normalise(name)]).sort((a,b)=>b[1].length-a[1].length);
  const filters=[...names,...Object.keys(stateNames).map(code=>[code,code.toLowerCase()])];
  filters.forEach(([code,name])=>{const pattern=new RegExp('(?:^|\\s)'+name+'(?=\\s|$)','g');if(pattern.test(remaining)){states.push(code);remaining=remaining.replace(pattern,' ');}});
  if(states.some(code=>code!==state))return false;
  const haystack=normalise(text);
  return remaining.split(/\s+/).filter(Boolean).every(word=>haystack.includes(word));
 }
 function matchesRange(tile,retainer,range){return range==='all'||(range==='retainer'?retainer:tile);}
 function coordinates(latitude,longitude){
  if(String(latitude).trim()===''||String(longitude).trim()==='')return null;
  const lat=Number(latitude),lng=Number(longitude);
  return Number.isFinite(lat)&&Number.isFinite(lng)&&lat>=-90&&lat<=90&&lng>=-180&&lng<=180?{lat,lng}:null;
 }
 function distanceKm(a,b){
  const radians=Math.PI/180,lat=(b.lat-a.lat)*radians,lng=(b.lng-a.lng)*radians;
  const h=Math.sin(lat/2)**2+Math.cos(a.lat*radians)*Math.cos(b.lat*radians)*Math.sin(lng/2)**2;
  return 6371*2*Math.atan2(Math.sqrt(Math.min(1,h)),Math.sqrt(Math.max(0,1-h)));
 }
 function formatDistance(km){return km<10?km.toFixed(1):String(Math.round(km));}
 function resolveLocation(index,query,state){
  if(!index)return null;
  let term=normalise(query),stateFilter=state;
  Object.entries(stateNames).sort((a,b)=>b[1].length-a[1].length).forEach(([code,name])=>{
   for(const token of [normalise(name),code.toLowerCase()]){const pattern=new RegExp('(?:^|\\s)'+token+'(?=\\s|$)','g');if(pattern.test(term)){if(stateFilter&&stateFilter!==code){term='';return;}stateFilter=code;term=term.replace(pattern,' ').trim();}}
  });
  if(!term)return null;
  function matchesState(postcode){const states=Array.isArray(postcode[2])?postcode[2]:[postcode[2]];return!stateFilter||states.includes(stateFilter);}
  if(/^\d{4}$/.test(term)){
   const postcode=index.postcodes?.[term];
   if(!Array.isArray(postcode)||!matchesState(postcode))return null;
   return coordinates(postcode[0],postcode[1]);
  }
  const placeTerm=term.replace(/[^a-z0-9]+/g,' ').replace(/\s+/g,' ').trim();
  const candidates=(index.suburbs?.[placeTerm]||[]).filter(reference=>Array.isArray(reference)&&(!stateFilter||reference[1]===stateFilter)&&Array.isArray(index.postcodes?.[reference[0]]));
  const postcodes=[...new Set(candidates.map(reference=>reference[0]))];
  const points=postcodes.map(postcode=>coordinates(index.postcodes[postcode][0],index.postcodes[postcode][1])).filter(Boolean);
  if(!points.length||points.some(point=>distanceKm(points[0],point)>1))return null;
  return{lat:points.reduce((sum,point)=>sum+point.lat,0)/points.length,lng:points.reduce((sum,point)=>sum+point.lng,0)/points.length};
 }
 function project(position,zoom){
  const size=256*Math.pow(2,zoom),latitude=Math.min(85.05112878,Math.max(-85.05112878,position.lat)),sin=Math.sin(latitude*Math.PI/180);
  return{x:(position.lng+180)/360*size,y:(.5-Math.log((1+sin)/(1-sin))/(4*Math.PI))*size};
 }
 function unproject(point,zoom){const size=256*Math.pow(2,zoom);return{lat:Math.atan(Math.sinh(Math.PI-2*Math.PI*point.y/size))*180/Math.PI,lng:point.x/size*360-180};}
 function fitPositions(positions,width,height){
  if(!positions.length)return{center:{lat:-25.3,lng:134.2},zoom:4};
  if(positions.length===1)return{center:positions[0],zoom:12};
  const points=positions.map(position=>project(position,0));
  const minX=Math.min(...points.map(point=>point.x)),maxX=Math.max(...points.map(point=>point.x));
  const minY=Math.min(...points.map(point=>point.y)),maxY=Math.max(...points.map(point=>point.y));
  let zoom=13;
  while(zoom>3&&((maxX-minX)*Math.pow(2,zoom)>Math.max(96,width-100)||(maxY-minY)*Math.pow(2,zoom)>Math.max(96,height-100)))zoom--;
  return{center:unproject({x:(minX+maxX)/2,y:(minY+maxY)/2},0),zoom};
 }
 function safeTileTemplate(value){
  try{const url=new URL(value.replace('{z}','3').replace('{x}','0').replace('{y}','0'));return url.protocol==='https:'&&!url.username&&!url.password&&['{z}','{x}','{y}'].every(token=>value.includes(token))?value:'https://tile.openstreetmap.org/{z}/{x}/{y}.png';}catch{return'https://tile.openstreetmap.org/{z}/{x}/{y}.png';}
 }
 function createMap(root,stores,chooseStore,signal){
  const element=root.querySelector('[data-stockist-map]'),tiles=root.querySelector('[data-stockist-map-tiles]'),pins=root.querySelector('[data-stockist-map-markers]'),status=root.querySelector('[data-stockist-map-status]');
  const zoomIn=root.querySelector('[data-map-zoom-in]'),zoomOut=root.querySelector('[data-map-zoom-out]'),fit=root.querySelector('[data-map-fit]');
  const template=safeTileTemplate(root.dataset.tileUrl),options={signal},tileNodes=new Map(),markerNodes=new Map();
  let center={lat:-25.3,lng:134.2},zoom=4,current=[],selected=null,drag=null,frame=0,disposed=false,fitPending=false;
  function render(){
   frame=0;if(disposed||element.closest('[hidden]'))return;
   const width=element.clientWidth,height=element.clientHeight;if(!width||!height)return;
   if(fitPending){const fitted=fitPositions(current.filter(store=>store.position).map(store=>store.position),width,height);center=fitted.center;zoom=fitted.zoom;fitPending=false;}
   const world=256*Math.pow(2,zoom),middle=project(center,zoom),left=middle.x-width/2,top=middle.y-height/2,needed=new Set(),limit=Math.pow(2,zoom);
   for(let y=Math.floor(top/256);y<=Math.floor((top+height-1)/256);y++){
    if(y<0||y>=limit)continue;
    for(let x=Math.floor(left/256);x<=Math.floor((left+width-1)/256);x++){
     const tileX=((x%limit)+limit)%limit,key=zoom+':'+x+':'+y;needed.add(key);
     let image=tileNodes.get(key);
     if(!image){image=document.createElement('img');image.alt='';image.draggable=false;image.width=256;image.height=256;image.referrerPolicy='strict-origin-when-cross-origin';image.decoding='async';image.src=template.replace('{z}',String(zoom)).replace('{x}',String(tileX)).replace('{y}',String(y));image.addEventListener('error',()=>{if(disposed)return;status.hidden=false;status.textContent=root.dataset.mapError;},{once:true,signal});tiles.append(image);tileNodes.set(key,image);}
     image.style.transform='translate('+Math.round(x*256-left)+'px,'+Math.round(y*256-top)+'px)';
    }
   }
   tileNodes.forEach((node,key)=>{if(!needed.has(key)){node.remove();tileNodes.delete(key);}});
   markerNodes.forEach((button,store)=>{
    const point=project(store.position,zoom);let dx=point.x-middle.x;if(dx>world/2)dx-=world;if(dx<-world/2)dx+=world;
    const x=width/2+dx,y=height/2+point.y-middle.y;
    button.hidden=x<0||x>width||y<0||y>height;button.style.left=x+'px';button.style.top=y+'px';button.setAttribute('aria-pressed',String(store===selected));
   });
   zoomIn.disabled=zoom>=18;zoomOut.disabled=zoom<=3;
  }
  function schedule(){if(!frame&&!disposed)frame=requestAnimationFrame(render);}
  function changeZoom(delta){zoom=Math.max(3,Math.min(18,zoom+delta));schedule();}
  function fitCurrent(){fitPending=true;schedule();}
  function selectStore(store){
   if(!store.position||!markerNodes.has(store))return;
   selected=store;center={...store.position};zoom=Math.max(zoom,14);fitPending=false;schedule();
  }
  function setStores(values,fitView=true){
   current=values;selected=null;
   markerNodes.forEach(button=>button.remove());markerNodes.clear();
   values.filter(store=>store.position).forEach(store=>{const button=document.createElement('button');button.type='button';button.className='clip-stockists__map-pin';button.setAttribute('aria-label',store.name);button.setAttribute('aria-pressed','false');button.setAttribute('aria-controls',root.querySelector('[data-stockist-map-selected]').id);button.addEventListener('click',()=>{selected=store;chooseStore(store);schedule();},options);pins.append(button);markerNodes.set(store,button);});
   const missing=values.filter(store=>!store.position).length;
   status.hidden=missing===0;
   status.textContent=values.length===missing?root.dataset.mapEmpty:root.dataset.mapNote.replace('[count]',String(missing));
   if(fitView)fitCurrent();else schedule();
  }
  zoomIn.addEventListener('click',()=>changeZoom(1),options);zoomOut.addEventListener('click',()=>changeZoom(-1),options);fit.addEventListener('click',fitCurrent,options);
  element.addEventListener('pointerdown',event=>{if(event.button!==0||event.target.closest('button,a'))return;drag={id:event.pointerId,x:event.clientX,y:event.clientY,center:project(center,zoom)};element.classList.add('is-dragging');element.setPointerCapture(event.pointerId);},options);
  element.addEventListener('pointermove',event=>{if(!drag||event.pointerId!==drag.id)return;const world=256*Math.pow(2,zoom),point={x:drag.center.x+drag.x-event.clientX,y:Math.max(0,Math.min(world,drag.center.y+drag.y-event.clientY))};point.x=((point.x%world)+world)%world;center=unproject(point,zoom);schedule();},options);
  function stopDrag(event){if(!drag||event.pointerId!==drag.id)return;drag=null;element.classList.remove('is-dragging');}
  element.addEventListener('pointerup',stopDrag,options);element.addEventListener('pointercancel',stopDrag,options);element.addEventListener('lostpointercapture',()=>{drag=null;element.classList.remove('is-dragging');},options);
  element.addEventListener('keydown',event=>{
   if(event.target!==element)return;
   const arrows={ArrowLeft:[-80,0],ArrowRight:[80,0],ArrowUp:[0,-80],ArrowDown:[0,80]};
   if(arrows[event.key]){event.preventDefault();const point=project(center,zoom),world=256*Math.pow(2,zoom);point.x=((point.x+arrows[event.key][0])%world+world)%world;point.y=Math.max(0,Math.min(world,point.y+arrows[event.key][1]));center=unproject(point,zoom);schedule();}
   else if(['+','=','-','Home'].includes(event.key)){event.preventDefault();event.key==='Home'?fitCurrent():changeZoom(event.key==='-'?-1:1);}
  },options);
  const observer=new ResizeObserver(()=>{if(!selected)fitPending=true;schedule();});observer.observe(element);
  signal.addEventListener('abort',()=>{disposed=true;cancelAnimationFrame(frame);observer.disconnect();tileNodes.clear();markerNodes.clear();},{once:true});
  setStores(stores);
  return{setStores,selectStore,refresh:schedule};
 }
 function initialise(root){
  if(root.dataset.ready)return;
  root.dataset.ready='true';
  const controller=new AbortController();
  const options={signal:controller.signal};
  const form=root.querySelector('[data-stockist-search-form]');
  const input=root.querySelector('[data-stockist-search]');
  const select=root.querySelector('[data-stockist-state]');
  const ranges=[...root.querySelectorAll('[data-stockist-range]')];
  const cards=[...root.querySelectorAll('[data-stockist-card]')];
  const resultCount=root.querySelector('[data-stockist-count]');
  const directory=root.querySelector('[data-stockist-directory]');
  const empty=root.querySelector('[data-stockist-empty]');
  const noMatch=root.querySelector('[data-stockist-no-match]');
  const resetButtons=[...root.querySelectorAll('[data-clear-stockist-search]')];
  const views=[...root.querySelectorAll('[data-stockist-view]')];
  const mapPanel=root.querySelector('[data-stockist-map-panel]');
  const selectedCard=root.querySelector('[data-stockist-map-selected]');
  const results=root.querySelector('[data-stockist-results]');
  const mapElement=root.querySelector('[data-stockist-map]');
  const stores=cards.map(card=>({card,name:card.querySelector('h3')?.textContent||'',search:card.dataset.search,state:card.dataset.state,tile:card.dataset.tile==='true',retainer:card.dataset.retainer==='true',priority:Number(card.dataset.priority)||0,position:coordinates(card.dataset.latitude,card.dataset.longitude)}));
  stores.sort((a,b)=>b.priority-a.priority||a.name.localeCompare(b.name,'en-AU',{sensitivity:'base'}));
  const sortedCards=document.createDocumentFragment();stores.forEach(store=>sortedCards.append(store.card));root.querySelector('[data-stockist-results]').prepend(sortedCards);
  let range='tile',view='list',map=null,filtered=[],locationIndex=null,indexPromise=null,indexLoading=false;
  const panelObserver=new ResizeObserver(()=>{
   if(!mapPanel||view!=='map'||mapPanel.hidden)return;
   const height=Math.ceil(mapPanel.getBoundingClientRect().height);
   if(height>0)directory.style.setProperty('--stockist-map-panel-height',height+'px');
  });
  if(mapPanel)panelObserver.observe(mapPanel);
  controller.signal.addEventListener('abort',()=>panelObserver.disconnect(),{once:true});
  function chooseFromList(store){
   const previousView=view;
   setView('map');map.selectStore(store);showStore(store);
   if(previousView==='list'||!window.matchMedia('(min-width:960px)').matches){
    mapElement.focus({preventScroll:true});
    mapElement.scrollIntoView({block:'start',behavior:window.matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'});
   }
  }
  stores.filter(store=>store.position&&mapPanel).forEach(store=>{
   const links=store.card.querySelector('.clip-stockists__store-links');
   if(!links)return;
   const button=store.card.querySelector('[data-stockist-show-map]')||document.createElement('button');
   button.type='button';button.className='clip-stockists__show-map';button.dataset.stockistShowMap='';
   button.textContent=root.dataset.showOnMap;button.setAttribute('aria-label',root.dataset.showOnMapLabel.replace('[name]',store.name));
   button.setAttribute('aria-controls',selectedCard.id);button.setAttribute('aria-pressed','false');
   links.prepend(button);store.mapButton=button;store.card.dataset.stockistSelectable='';
   button.addEventListener('click',()=>chooseFromList(store),options);
   store.card.addEventListener('click',event=>{
    if(event.target.closest('a,button,input,select,textarea')||window.getSelection()?.toString())return;
    chooseFromList(store);
   },options);
  });
  async function loadLocationIndex(){
   if(indexPromise)return indexPromise;
   indexLoading=true;
   indexPromise=(async()=>{
    try{
     const url=new URL(root.dataset.locationIndexUrl,location.href);
     if(url.protocol!=='https:'||url.origin!==location.origin&&url.hostname!=='cdn.shopify.com')return null;
     const response=await fetch(url.href,{credentials:url.origin===location.origin?'same-origin':'omit'});
     if(!response.ok)return null;
     const data=await response.json();
     if(data.version!==1||!data.postcodes||!data.suburbs)return null;
     if(controller.signal.aborted)return null;
     locationIndex=data;root.querySelector('[data-locality-credit]').hidden=false;return data;
    }catch{return null;}
   })().finally(()=>{indexLoading=false;});
   indexPromise.then(()=>{if(!controller.signal.aborted)search();});
   return indexPromise;
  }
  function setUrl(){const url=new URL(location.href);if(range==='tile')url.searchParams.delete('range');else url.searchParams.set('range',range);if(input.value.trim())url.searchParams.set('q',input.value.trim());else url.searchParams.delete('q');if(select.value)url.searchParams.set('state',select.value);else url.searchParams.delete('state');history.replaceState(null,'',url);}
  function showStore(store){
   if(!selectedCard)return;
   stores.forEach(item=>{item.card.classList.toggle('is-selected',item===store);item.mapButton?.setAttribute('aria-pressed',String(item===store));});
   const clone=store.card.cloneNode(true);clone.removeAttribute('data-stockist-card');clone.removeAttribute('data-stockist-selectable');clone.removeAttribute('id');clone.querySelector('[data-stockist-show-map]')?.remove();clone.hidden=false;
   selectedCard.replaceChildren(clone);selectedCard.hidden=false;
   if(view==='map'&&window.matchMedia('(min-width:960px)').matches){
    const offset=store.card.getBoundingClientRect().top-results.getBoundingClientRect().top+results.scrollTop-24;
    results.scrollTo({top:offset,behavior:window.matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'});
   }
  }
  function search(updateUrl=false){
   if(!indexPromise&&input.value.trim().length>=3)loadLocationIndex();
   const postcodeLoading=indexLoading&&/^\d{4}$/.test(input.value.trim());
   const rangeStores=stores.filter(store=>matchesRange(store.tile,store.retainer,range));
   const location=resolveLocation(locationIndex,input.value,select.value);
   const stateStores=rangeStores.filter(store=>!select.value||store.state===select.value);
   let ordered=[],unlocated=[];
   if(location){
    ordered=stateStores.filter(store=>store.position).map(store=>({store,distance:distanceKm(location,store.position)})).sort((a,b)=>a.distance-b.distance||a.store.name.localeCompare(b.store.name,'en-AU',{sensitivity:'base'})).slice(0,20);
    unlocated=stateStores.filter(store=>!store.position&&matchesStockist(store.search,input.value,store.state));
    filtered=[...ordered.map(item=>item.store),...unlocated];
   }else filtered=stateStores.filter(store=>matchesStockist(store.search,input.value,store.state));
   const shown=new Set(filtered);
   stores.forEach(store=>{store.card.hidden=!shown.has(store);});
   const distances=new Map(ordered.map(item=>[item.store,item.distance]));
   stores.forEach(store=>{const output=store.card.querySelector('[data-stockist-distance]');output.hidden=!distances.has(store);output.textContent=distances.has(store)?root.dataset.distanceTemplate.replace('[distance]',formatDistance(distances.get(store))):'';});
   const reordered=document.createDocumentFragment();filtered.forEach(store=>reordered.append(store.card));stores.filter(store=>!shown.has(store)).forEach(store=>reordered.append(store.card));root.querySelector('[data-stockist-results]').prepend(reordered);
   resultCount.textContent=location&&unlocated.length===0?(filtered.length===1?root.dataset.nearestOne:root.dataset.nearestCount.replace('[count]',String(filtered.length))):(filtered.length===1?root.dataset.countOne:root.dataset.countTemplate.replace('[count]',String(filtered.length)));
   if(postcodeLoading)resultCount.textContent=root.dataset.locationsLoading;
   empty.hidden=rangeStores.length>0;noMatch.hidden=rangeStores.length===0||filtered.length>0||postcodeLoading;
   root.querySelector('[data-retainer-buy]').hidden=range!=='retainer';
   const narrowed=Boolean(input.value.trim()||select.value);
   resetButtons[0].hidden=!narrowed;
   directory.hidden=filtered.length===0;
   if(selectedCard){selectedCard.replaceChildren();selectedCard.hidden=true;}
   stores.forEach(store=>{store.card.classList.remove('is-selected');store.mapButton?.setAttribute('aria-pressed','false');});
   if(map)map.setStores(filtered);
   if(updateUrl)setUrl();
  }
  function setView(value){
   view=value==='map'&&mapPanel?'map':'list';directory.dataset.view=view;
   views.forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.stockistView===view)));
   if(mapPanel)mapPanel.hidden=view!=='map';
   if(view==='map'){
    if(!map)map=createMap(root,filtered,showStore,controller.signal);else map.refresh();
   }
  }
  function fromUrl(){
   const params=new URL(location.href).searchParams;
   range=['tile','retainer','all'].includes(params.get('range'))?params.get('range'):'tile';
   ranges.forEach(radio=>{radio.checked=radio.value===range;});
   input.value=(params.get('q')||'').slice(0,120);select.value=Object.hasOwn(stateNames,params.get('state'))?params.get('state'):'';
   search();
  }
  ranges.forEach(radio=>radio.addEventListener('change',()=>{if(radio.checked){range=radio.value;search(true);}},options));
  form.addEventListener('submit',event=>{event.preventDefault();search(true);},options);
  input.addEventListener('input',()=>search(true),options);
  select.addEventListener('change',()=>search(true),options);
  resetButtons.forEach(button=>button.addEventListener('click',()=>{input.value='';select.value='';search(true);input.focus();},options));
  views.forEach(button=>button.addEventListener('click',()=>setView(button.dataset.stockistView),options));
  window.addEventListener('popstate',fromUrl,options);
  document.addEventListener('shopify:block:select',event=>{if(!root.contains(event.target))return;range='retainer';ranges.forEach(radio=>{radio.checked=radio.value===range;});input.value='';select.value='';setView('list');search();},options);
  document.addEventListener('shopify:section:unload',event=>{if(!event.target.contains(root))return;controller.abort();delete root.dataset.ready;},options);
  fromUrl();setView(window.matchMedia('(min-width:960px)').matches?'map':'list');
 }
 function scan(){document.querySelectorAll('[data-native-stockists]').forEach(initialise);}
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',scan,{once:true});else scan();
 document.addEventListener('shopify:section:load',scan);
})();
  } catch(e) { console.error(e); }
})();

})();
